import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import type { SiteControllerSettingTemairazuFormModel } from "@/components/features/settings/site-controller/model/temairazu/type";
import type { SiteControllerSettingTemairazuFormModelMethodsType } from "@/components/features/settings/site-controller/model/temairazu/use-case/use-create-model/methods";

import { InputPasswordField } from "@/components/ui/form/fields/input-field/input-password";

type Props = {
	hotelID: SiteControllerSettingTemairazuFormModel["ViewModel"]["hotelID"]; //
	password: SiteControllerSettingTemairazuFormModel["ViewModel"]["password"]; //
	onSetPassword: SiteControllerSettingTemairazuFormModelMethodsType["siteControllerSettingNeppanFormModelMethods"]["onSetPassword"];
};

export const SettingsSiteControllerTemairazuPassword = ({ hotelID, password, onSetPassword }: Props) => {
	return (
		<QuestionForMain
			guide="パスワードは、CHILLNNのログインパスワードとは異なるパスワードを自由に設定が可能です。<br />表示されているIDと設定したパスワードをご利用のサイトコントローラーに登録しましょう。"
			required={true}
			title={"パスワード"}
			inputChildren={
				<div className="space-y-4">
					<div>
						<p>ログインID</p>
						<p className="font-semibold">{hotelID}</p>
					</div>
					<InputPasswordField
						label="パスワード"
						className="w-full xl:w-1/2"
						value={password?.value}
						errorMessage={password?.error}
						onChange={onSetPassword}
					/>
				</div>
			}
		/>
	);
};

SettingsSiteControllerTemairazuPassword.displayName = "SettingsSiteControllerTemairazuPassword";
